export { default } from './RoomPhoto';
